export const SUCCESS_CARDS = "SUCCESS_CARDS";

export const SUCCESS_COUPONS = "SUCCESS_COUPONS";
export const SUCCESS_ADD_COUPON = "SUCCESS_ADD_COUPON";
export const REJECTED_ADD_COUPON = "REJECTED_ADD_COUPON";

